export class OktaConstant {
  static readonly Messages = {
    ActivateUserPasswordHintMessage:
      'Your password must have at least 6 characters, contain one of each of the following: a lowercase letter, an uppercase letter, ' +
      'a number and a special character (-!"#$%&\'()*+,./:;<=>?[@]) and cannot be the same as your username.',
    ChangePasswordHintMessage:
      'Your password must have at least 6 characters, contain one of each of the following: a lowercase letter, an uppercase letter, ' +
      'a number and a special character (-!"#$%&\'()*+,./:;<=>?[@]) and cannot be the same as your username or your previous 9 passwords.',
    IdetificationRequiredMesssage: 'Username is required.',
    SecurityAnswerRequiredMesssage: 'Recovery answer is required.',
    SecurityQuestionUpdatedMesssage:
      'Security question has been updated successfully.',
    ResetPasswordSuccessMesssage: 'Password has been reset successfully.',
    UserActivationSuccessMesssage:
      'Your account has been activated successfully.',
    TokenExpiredMessage: 'The link that you have visited is no longer valid.',
    ActivationTokenExpiredMessage:
      'Your account activation link is no longer valid. ' +
      'Please contact Customer Service at 800.727.6331 for assistance.',
    MajorActivationTokenExpiredMessage:
      'Your account activation link is no longer valid. ' +
      'Please contact Customer Service at 800.616.2471 for assistance.',
    NonMigrateTokenExpiredMessage:
      'Your session has expired. Please re-login and activate your account.',
    ChangePasswordSuccessMesssage: 'Password has been changed successfully.',
    ActivateUserSuccessMesssage: 'User has been activated successfully.',
    AccountUnlockedSuccessMesssage: 'Account has been unlocked successfully.',

    InvalidUserNamePasswordMesssage:
      'Invalid username or password. Please try again.',
    ParmedAccessDeniedMessage:
      'You do not have permission to access ParMed application.',
    UserLockedMessage:
      'Your account is locked. Please contact our ' +
      'Customer Service department at 800.727.6331 for assistance with unlocking your account.'
  };

  static readonly SecurityAnswer = {
    LengthRegex: /^.{5,}$/,
    MinLength: 5,
    ValidationMessage: 'Your answer must have at least 5 characters.'
  };
}
